import { t } from "@/i18n-js/instance";
import { TRIGGER_RESOURCE_TYPE } from "@circle-react/components/SettingsApp/Workflows/constants";
import { FormTextSelect } from "@circle-react/components/shared/uikit/Form/FormTextSelect";
import type { SpaceType } from "@circle-react/types/Space";
import { Typography } from "@circle-react-uikit/Typography";
import { AdminSelector } from "../Admin/AdminSelector";
import { HiddenCommunityInputs } from "../Community/shared/HiddenCommunityInputs";
import { LessonSelector } from "../Course/shared/LessonSelector";
import { SectionSelector } from "../Course/shared/SectionSelector";
import { WhichEventSelector } from "../Event/shared/WhichEventSelector";
import { WhichPaywallSelector } from "../Paywall/shared/WhichPaywallSelector";
import { WhichPaywallCouponSelector } from "../PaywallCoupon/WhichPaywallCouponSelector";
import { PostSelector } from "../PostBasic/shared/PostSelector";
import { CourseSelector } from "../Space/shared/CourseSelector";
import { SpaceSelector } from "../Space/shared/SpaceSelector";
import { SpaceGroupSelector } from "../SpaceGroup/shared/SpaceGroupSelector";
import { useEntitySelector } from "./useEntitySelector";

const i18nRoot = "settings.workflows.form";

const componentsMap = {
  [TRIGGER_RESOURCE_TYPE.COMMUNITY]: HiddenCommunityInputs,
  [TRIGGER_RESOURCE_TYPE.SPACE_GROUP]: SpaceGroupSelector,
  [TRIGGER_RESOURCE_TYPE.SPACE]: SpaceSelector,
  // @ts-expect-error - COURSE_SPACE doesn't exist in TRIGGER_RESOURCE_TYPE, evaluates to undefined
  [TRIGGER_RESOURCE_TYPE.COURSE_SPACE]: CourseSelector,
  [TRIGGER_RESOURCE_TYPE.POST_BASIC]: PostSelector,
  [TRIGGER_RESOURCE_TYPE.EVENT]: WhichEventSelector,
  [TRIGGER_RESOURCE_TYPE.LESSON]: LessonSelector,
  [TRIGGER_RESOURCE_TYPE.SECTION]: SectionSelector,
  [TRIGGER_RESOURCE_TYPE.COMMUNITY_MEMBER_ADMIN]: AdminSelector,
  [TRIGGER_RESOURCE_TYPE.PAYWALL]: WhichPaywallSelector,
  [TRIGGER_RESOURCE_TYPE.PAYWALL_COUPON]: WhichPaywallCouponSelector,
} as const;

interface EntityTypeOption {
  description?: string;
  label: string;
  value: string;
}

interface EntitySelectorProps {
  entityTypeOptions: EntityTypeOption[];
  isQuizSelector?: boolean;
  resourceType?: SpaceType;
}

export const EntitySelector = ({
  entityTypeOptions,
  ...props
}: EntitySelectorProps): JSX.Element => {
  const { resourceType, handleEntitySelectorChange } = useEntitySelector();
  const Component =
    componentsMap[resourceType as keyof typeof componentsMap] || null;

  return (
    <>
      <FormTextSelect
        name="trigger.resource_type"
        options={entityTypeOptions}
        label={
          <Typography.LabelSm weight="semibold">
            {t([i18nRoot, "choose_entity"])}
          </Typography.LabelSm>
        }
        onChange={handleEntitySelectorChange}
      />
      {Component && <Component {...props} />}
    </>
  );
};
